import { Button } from '@mui/material';
import { MaterialIcon } from '@components';
import { ListFilterSelectWrapFooter } from './common';

interface ListFilterSelectFooterProps {
  onAction: () => void;
  actionText: string;
  actionIcon?: string;
}

export default function ListFilterSelectFooter({
  onAction,
  actionText,
  actionIcon = 'add',
}: ListFilterSelectFooterProps) {
  return (
    <ListFilterSelectWrapFooter>
      <Button startIcon={<MaterialIcon symbol={actionIcon} />} onClick={onAction} size="small" variant="text">
        {actionText}
      </Button>
    </ListFilterSelectWrapFooter>
  );
}
